import { createAction } from '@reduxjs/toolkit';

export const toggleSidebar = createAction('[Layout] Toggle sidebar');

export default toggleSidebar;
